import { setSession, getSession, removeSession } from '@utils/storage.js';
import { UPDATESHARE, REMOVESHARE } from '../types';
export default {
  namespaced: true,
  state: {
    shareInfo: getSession('shareInfo')
  },
  mutations: {
    [UPDATESHARE] (state, shareInfo) {
      state.shareInfo = Object.assign({}, state.shareInfo, shareInfo);
      setSession('shareInfo', state.shareInfo);
    },
    [REMOVESHARE] (state) {
      state.shareInfo = {};
      removeSession('shareInfo');
    }
  },
  actions: {
    updateShare ({ commit }, shareInfo) {
      commit(UPDATESHARE, shareInfo);
    },
    removeShare ({ commit }) {
      commit(REMOVESHARE);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/share.js